module.exports = __webpack_public_path__ + "static/media/hapticGoRoundImg5.890abf00.jpg";